/**
 * PostMessage protocol for Mobile Studio Builder ↔ Storefront iframe communication.
 *
 * Admin (work.zaviago.com) sends config updates to storefront iframe (*.shop.zaviago.com).
 * Storefront sends PREVIEW_READY when its React app has mounted and is ready to receive.
 */

// --- Message type constants ---

export const MSG_MOBILE_CONFIG_UPDATE = 'MOBILE_CONFIG_UPDATE' as const
export const MSG_PREVIEW_TOKEN_REFRESH = 'PREVIEW_TOKEN_REFRESH' as const
export const MSG_PREVIEW_READY = 'PREVIEW_READY' as const

// --- Message interfaces ---

export interface MobileConfigUpdateMessage {
  type: typeof MSG_MOBILE_CONFIG_UPDATE
  config: {
    preset: string
    nav_style: string
    search_placement: string
    category_layout: string
    product_list_layout: string
    table_row_density: string
    table_image_size: string
    default_view: string
    table_show_sku?: boolean
    table_show_collections?: boolean
    table_show_price?: boolean
    table_show_add_to_cart?: boolean
    bottom_tab_items?: Array<{
      id: string
      icon: string
      label: string
      route: string
      visible: boolean
    }>
  }
}

export interface PreviewTokenRefreshMessage {
  type: typeof MSG_PREVIEW_TOKEN_REFRESH
  token: string
}

export interface PreviewReadyMessage {
  type: typeof MSG_PREVIEW_READY
}

export type PreviewMessage =
  | MobileConfigUpdateMessage
  | PreviewTokenRefreshMessage
  | PreviewReadyMessage

// --- Origin validation ---

export function isAllowedStorefrontOrigin(origin: string, configuredOrigin?: string): boolean {
  if (configuredOrigin && origin === configuredOrigin) return true
  if (/^https?:\/\/[a-z0-9-]+\.shop\.zaviago\.com$/.test(origin)) return true
  // Allow localhost only in dev mode
  if (import.meta.env.DEV && origin === 'http://localhost:3000') return true
  return false
}
